import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { OfferProposerRole } from "@hybrid-escrow/shared";
import { apiClient } from "../lib/api-client";
import { queryKeys } from "../lib/queryClient";
import { POLL } from "../lib/polling";
import { Money } from "../components/Money";
import { OfferStatusBadge } from "../components/StatusBadge";
import { OfferActions } from "../components/OfferActions";
import { EmptyState, ErrorBanner, LoadingState } from "../components/States";
import { usePageMeta } from "../lib/seo";

export function SellerOffersPage() {
  usePageMeta({
    title: "Offers on your listings",
    description: "Best Offer negotiations from buyers on your listings.",
    path: "/sell/offers",
    index: false,
  });

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.sellerOffers,
    queryFn: ({ signal }) => apiClient.getSellerOffers({}, signal),
    refetchInterval: POLL.list,
  });

  return (
    <div className="stack">
      <h1>Offers on your listings</h1>
      <p className="muted">Best Offer proposals buyers have sent you.</p>

      {isLoading && <LoadingState label="Loading offers…" />}
      {isError && <ErrorBanner error={error} onRetry={() => void refetch()} />}
      {data && data.items.length === 0 && (
        <EmptyState title="No offers yet">
          <p>When a buyer makes an offer on one of your listings, it'll show up here.</p>
        </EmptyState>
      )}

      {data && data.items.length > 0 && (
        <div className="stack" style={{ gap: "var(--space-2)" }}>
          {data.items.map((offer) => (
            <div key={offer.id} className="card stack">
              <div className="row row--between">
                <Link to={`/listings/${offer.listingId}`}>
                  <strong>{offer.listingTitle}</strong>
                </Link>
                <OfferStatusBadge status={offer.status} />
              </div>
              <div className="row row--between">
                <span className="text-sm muted">
                  From {offer.buyerUsername ?? "a buyer"} · listed at{" "}
                  <Money baseUnits={offer.listingPriceBaseUnits} className="text-sm" />
                </span>
                <span>
                  Current offer: <Money baseUnits={offer.currentAmountBaseUnits} />
                </span>
              </div>
              <OfferActions offer={offer} viewerRole={OfferProposerRole.SELLER} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
